/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { Popover } from './popover';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { createPopoverCloseEvent } from './create-close-event';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { TPopoverCloseReason, TPopoverProps, TPlacementOptions } from './types';
